export const GRID_ROW_HOVER = 'GRID_ROW_HOVER';

export const updateHoveredRow = rowLabel => ({
    type: GRID_ROW_HOVER,
    rowLabel,
});
